import { Routes } from '@angular/router';

import { applicationRouteNames } from './application-route-names';
import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { hasPermission } from './guards/permission.guard';
import { redirectToFirstAvailableRoute } from './guards/redirect-to-first-available.guard';

export const applicationRoutes: Routes = [
  {
    path: '',
    canActivate: [MpsLoggedInGuard, redirectToFirstAvailableRoute],
    children: [],
  },
  {
    path: applicationRouteNames.monitoring,
    loadChildren: () => import('./monitoring/monitoring.routes').then((m) => m.monitoringRoutes),
    data: { title: 'menu.monitoring', requiredPermission: ['error-log', 'subscription-log'] },
    canActivate: [MpsLoggedInGuard, hasPermission('error-log')],
    canLoad: [],
  },
  {
    path: applicationRouteNames.subscriptionConfiguration,
    loadChildren: () =>
      import('./subscription-configuration/subscription-configuration.routes').then(
        (m) => m.subscriptionConfigurationRoutes
      ),
    data: { title: 'monitoring.navigation.subscription_config', requiredPermission: 'subscription-configuration' },
    canActivate: [hasPermission('subscription-configuration')],
  },
  {
    path: applicationRouteNames.administration,
    data: { title: 'monitoring.navigation.administration', requiredPermission: 'users-management' },
    canActivate: [hasPermission('users-management')],
    canLoad: [hasPermission('users-management')],
    children: [
      {
        path: applicationRouteNames.users,
        loadComponent: () => import('./administration/users/list/list.component').then((m) => m.ListComponent),
        data: { title: 'monitoring.navigation.users' },
        canActivate: [hasPermission('users-management')],
        canLoad: [hasPermission('users-management')],
      },
    ],
  },
  {
    path: applicationRouteNames.lokalise,
    loadComponent: () => import('./administration/lokalise/lokalise.component').then((m) => m.LokaliseComponent),
    data: { title: 'monitoring.navigation.lokalise' },
    canActivate: [MpsLoggedInGuard],
  },
];
